import { I18nType } from '@/ui/types/i18n.types';

const componentName = 'forms';
const submodule = 'errors';

export default function maxLengthRule(i18n: I18nType) {
  return function rule(property: string, maxLength = 10) {
    return [
      (v: string) => (v && v.length <= maxLength)
        || i18n.getFormattedText(componentName, submodule, 'maxLength', { property, max: maxLength }),
    ];
  };
}
